export default __webpack_public_path__ + "static/media/student_wel_en.191a5959.jpg";